import { useCallback, useState } from "react";

type Eff<T> = () => Promise<T>;

export function useWithPendingState<Key>() {
  const [updatingKey, setUpdatingKey] = useState<{ key: Key; details: Record<string, string> } | null>(null);

  const withUIPendingState = useCallback(
    (key: { key: Key; details: Record<string, string> }) => <T>(eff: Eff<T>): Promise<T> => {
      setUpdatingKey(key);

      return eff().finally(() => {
        setUpdatingKey(null);
      });
    },
    [],
  );

  return [updatingKey, withUIPendingState] as const;
}
